import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { TeamsProvider } from './context/TeamsContext'
import { ConfigProvider } from './context/ConfigContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <TeamsProvider>
          <ConfigProvider>
            <App />
          </ConfigProvider>
        </TeamsProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
